export type HttpUrl = `http${string}`;

export type Mode = 'light' | 'dark' | 'auto';

type HexColor = `#${string}`;

type Unit = `${number}px` | `${number}rem`;

export type CustomTheme = {
  // font
  '--pcm-font-family'?: string;

  // focus color, input etc.
  '--pcm-focus-color'?: string;

  // modal
  '--pcm-overlay-background'?: string;
  '--pcm-overlay-backdrop-filter'?: string; // default: blur(6px)
  '--pcm-modal-box-shadow'?: string;
  '--pcm-modal-max-height'?: string;

  // border radius
  '--pcm-rounded-sm'?: Unit; // 6px
  '--pcm-rounded-md'?: Unit; // 12px
  '--pcm-rounded-lg'?: Unit; // 18px
  '--pcm-rounded-xl'?: Unit; // 24px
  '--pcm-rounded-full'?: Unit; // 9999px

  // background
  '--pcm-body-background'?: string;
  '--pcm-body-background-secondary'?: string;
  '--pcm-body-background-tertiary'?: string;

  // foreground: font color
  '--pcm-body-color'?: string;
  '--pcm-body-color-secondary'?: string;
  '--pcm-body-color-tertiary'?: string;

  // button
  '--pcm-button-border-color'?: string;
  '--pcm-button-font-weight'?: string;
  '--pcm-button-hover-shadow'?: string;

  // primary button
  '--pcm-primary-button-color'?: string;
  '--pcm-primary-button-bankground'?: string;
  '--pcm-primary-button-hover-background'?: string; // TODO: 可根据bankground计算出来，不用自定义？

  // secondary button
  '--pcm-secondary-button-color'?: string;
  '--pcm-secondary-button-bankground'?: string;
  '--pcm-secondary-button-hover-background'?: string; // TODO: 可根据bankground计算出来，不用自定义？

  // action button color
  '--pcm-body-action-color'?: string;

  // accent color
  '--pcm-accent-color'?: string;

  // error
  '--pcm-error-color'?: HexColor;

  // success
  '--pcm-success-color'?: HexColor;

  // warning
  '--pcm-warning-color'?: HexColor;

  // custom wallet lable color
  '--pcm-wallet-lable-color'?: HexColor;
};

export type Theme = CustomTheme;

export enum ConnectorType {
  Email = 'email',
  Phone = 'phone',
  Social = 'social',
  Wallet = 'wallet',
  Passkey = 'passkey',
}

export type ConnectorTypeValue = `${ConnectorType}`;

export const EmailRegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export interface CloudflareOptions {
  getContainer?: HTMLElement | (() => HTMLElement) | false;
  theme?: 'light' | 'dark';
  language?: string;
}
